import { InteractionType } from '@azure/msal-browser'
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsalAuthentication
} from '@azure/msal-react'
import { Container, Footer, Modal, SiteLayout } from '@sainsburys-tech/luna-react'
import { useContext, useEffect, useState } from 'react'
import { Route, Routes, useLocation, Navigate } from 'react-router-dom'
import NavHeader from './components/Header/NavHeader'
import Loading from './components/Loading'
import { AppContext } from './context/AppContext'
import useCurrentStore from './hooks/useCurrentStore'
import useStoreLoader from './hooks/useStoreLoader'
import IncidentsPage from './pages/IncidentsPage'
import ReportingPage from './pages/ReportingPage'
import './scss/main.scss'
import { IStore } from './types/IStore'

const App = () => {
  const context = useContext(AppContext)

  useMsalAuthentication(InteractionType.Redirect, {
    scopes: [context?.apiScope ?? '']
  })

  const location = useLocation()
  const currentStore = useCurrentStore()
  const [store, setStore] = useState(currentStore)
  const [storeResource, loadStore] = useStoreLoader()

  useEffect(() => {
    if (
      context?.store !== undefined &&
      store.storeCode !== context!.store!.storeCode
    )
      setStore(context!.store!)
  }, [location, context?.store, store.storeCode])

  useEffect(() => {
    if (currentStore.storeCode) {
      loadStore.current(currentStore.storeCode)
    }
  }, [context, currentStore.storeCode, loadStore])

  useEffect(() => {
    if (
      context &&
      storeResource.data &&
      storeResource.hasLoaded &&
      !storeResource.hasError
    ) {
      const storeDetails = storeResource.data
      const newStore: IStore = {
        storeCode: storeDetails.code,
        storeName: storeDetails.name,
        inScope: storeDetails ? true : false
      }

      if (!context.store || context.store.storeCode !== newStore.storeCode) {
        context.store = newStore
        setStore(newStore)
      }
    }
  }, [
    context,
    storeResource.data,
    storeResource.hasLoaded,
    storeResource.hasError
  ])

  if (
    currentStore.storeCode &&
    !storeResource.hasLoaded &&
    !storeResource.hasError
  ) {
    return <Loading />
  }

  return (
    <>
      <AuthenticatedTemplate>
        <SiteLayout>
          <NavHeader />
          <Container size="md" soft>
            <main id="main-content" className="ln-u-push-top-md">
              <Pages />
            </main>
          </Container>
          <Footer>&copy; Sainsbury&apos;s Supermarkets Ltd</Footer>
        </SiteLayout>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Modal restrictClose open={true}>
          <h4> Redirecting... </h4>
        </Modal>
      </UnauthenticatedTemplate>
    </>
  )
}

const Pages = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/return-to-pay" replace />} />
      <Route path="/survey/:transactionId" element={<ReportingPage />} />
      <Route path="/return-to-pay" element={<IncidentsPage />} />
    </Routes>
  )
}

export default App
